import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/coin-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-73b29f81")

_pushScopeId("data-v-73b29f81")
const _hoisted_1 = { class: "shop" }
const _hoisted_2 = { class: "shop-headline-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "txt txt-medium shop-headline" }, "オンリーコイン購入", -1)
const _hoisted_4 = {
  key: 0,
  class: "procession-coins-box"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "txt txt-small procession-coins-headline" }, "所持コイン", -1)
const _hoisted_6 = { class: "coins-box" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "coins-icon",
  src: _imports_0
}, null, -1)
const _hoisted_8 = { class: "txt txt-small coins" }
const _hoisted_9 = { class: "shop-coins-container" }
const _hoisted_10 = { class: "shop-coins-box" }
const _hoisted_11 = { class: "coins-box" }
const _hoisted_12 = {
  key: 0,
  class: "txt txt-small coins"
}
const _hoisted_13 = {
  key: 1,
  class: "txt txt-small coins"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SignInModal = _resolveComponent("SignInModal")
  const _component_Loading = _resolveComponent("Loading")
  const _component_CoinSVG = _resolveComponent("CoinSVG")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showSignInModal)
      ? (_openBlock(), _createBlock(_component_SignInModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSignInModal = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, { isActive: _ctx.isLoading }, null, 8, ["isActive"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.showBalance)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.formatNumber(_ctx.balance)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("ul", _hoisted_9, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
        return (_openBlock(), _createBlock("li", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_CoinSVG, { class: "coins-icon" }),
            (product.earned > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.formatNumber((product.paid + product.earned + product.limitedPoint))) + "（" + _toDisplayString(_ctx.formatNumber(product.paid)) + " + " + _toDisplayString(_ctx.formatNumber((product.earned + product.limitedPoint))) + "）", 1))
              : (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.formatNumber((product.paid + product.earned + product.limitedPoint))), 1))
          ]),
          _createVNode(_component_BaseRoundRectButton, {
            class: "txt",
            text: _ctx.price(product.amount),
            onClick: ($event: any) => (_ctx.toPaymentPage(product))
          }, null, 8, ["text", "onClick"])
        ]))
      }), 256))
    ])
  ]))
})